{
  "actions": "Åtgärder"
}
